import React from 'react';
interface BrandLogoProps {
  /** Explicit width in pixels. The image keeps its natural aspect ratio. */
  widthPx?: number;
  /**
   * Visual variant:
   * - 'default': dark green mark, optimized for light backgrounds (uses multiply blend to remove the white background).
   * - 'white': inverted to pure white, optimized for dark backgrounds.
   */
  variant?: 'default' | 'white';
  className?: string;
}
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/4MTAqaLxfypSrp5NugZvnb/ChatGPT_Image_17_may_2026,_09_47_57_p.m..png';
export const BrandLogo: React.FC<BrandLogoProps> = ({
  widthPx = 120,
  variant = 'default',
  className = ''
}) => {
  const isWhite = variant === 'white';
  return <img src={LOGO_SRC} alt="El Código del Bienestar" style={{
    width: `${widthPx}px`,
    mixBlendMode: isWhite ? 'screen' : 'multiply',
    filter: isWhite ? 'brightness(0) invert(1)' : undefined
  }} className={`h-auto object-contain ${className}`} data-id="element-13" />;
};